import { openFibMigration } from '@fiverr-private/business_blocks';
import { PAGE_NAME } from '../events';

/**
 * @param {string} trigger
 * @param {Function} flowCallback
 */
export const triggerFibMigrationPopup = (trigger, flowCallback) => {
    const isMounted = openFibMigration({
        biEnrichment: {
            pageName: PAGE_NAME,
            trigger
        },
        onError: flowCallback,
        onLoadError: flowCallback,
        onSkip: flowCallback,
        onSuccess: flowCallback
    });
    if (!isMounted){
        flowCallback();
    }
};
